import { ListName } from '@aibees/elephant/feature/list-management-table/components/list-name';
import { Label } from '@aibees/elephant/types/label';
import { TextEllipsis } from '@aibees/shared/components';
import { AdvanceTableConfig } from '@aibees/shared/features';
import { fHumanReadableNumber, userGetShortName } from '@aibees/shared/utils';
import { CardBodyTotalRecords } from '../../styles';
import { ListSearchTableAction } from './actions/llist-search-table-action';
import * as SX from './sx';

export const config: Omit<AdvanceTableConfig<Label>, 'browseApi'> = {
  columns: [
    {
      id: 'name',
      label: 'Name',
      sortable: true,
      width: 132,
      render: (_, v) => <ListName item={v} />,
    },
    {
      id: 'records',
      label: 'Total Records',
      sortable: true,
      width: 90,
      render: (v) => (
        <CardBodyTotalRecords>{fHumanReadableNumber(v)}</CardBodyTotalRecords>
      ),
    },
    {
      id: 'workspace',
      label: 'Team',
      sortable: true,
      width: 56,
      render: (_, v) => (
        <TextEllipsis
          value={userGetShortName(v.workspace.user)}
          variant="body4"
          color="grey.700"
        />
      ),
    },
  ],
  actions: [ListSearchTableAction],
  filters: [],
  actionsConfig: {
    label: 'Action',
    minWidth: '10%',
    align: 'center',
    sx: { display: 'flex', justifyContent: 'center' },
  },
  hidePagination: true,
  stickyHeader: true,
  defaultOrderBy: 'modified',
  hideColumnsOnNoData: true,
  emptyProps: {
    emptyIcon: 'list',
    emptyIconWrapperSX: SX.emptyIconWrapper,
    titleSx: { fontSize: 14 },
    iconSize: 28,
  },
  hideResetFilters: true,
  cellSx: { p: 1 },
  bordered: 'solid',
};
